import React from 'react';
import PropTypes from 'prop-types';
import './Icon.scss';

const Icon = ({ background, color, size, icon }) => {
  const backgroundClass = background
    ? `icon--background icon--background-${background}`
    : '';

  return (
    <svg
      className={`icon icon--color-${color} icon--size-${size} ${backgroundClass}`}
      width={50}
      height={50}
      viewBox={'0 0 50 50'}
    >
      <path d={icon} />
    </svg>
  );
};

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
};

Icon.defaultProps = {
  size: 'default',
  color: 'default',
  background: '',
};

export default Icon;
